import { defineStore } from 'pinia';
import { get } from '~/utils/api';
import type { BigTicketAvailabilityProductDataDefault } from '~/modules/availability/composables/useAvailabilityBigTicket';

export interface BTResponse {
  products: {
    product: BigTicketAvailabilityProductDataDefault[];
  };
}
export interface AvailabilityBigTicketStoreState {
  data: Record<string, BTResponse>;
  zipCode: string;
  zipcodeSlideoutShown: boolean;
  previouslyFocusedElement: Element | null;
  activeSlideout: number | null;
}

export interface fetchParams {
  zipCode: string | null;
  lookupIds: string;
}

const buildUrl = (lookupIds: string, zipCode: string | null): string => `/xapi/digital/v1/product/bigticket/check/${lookupIds}?zipcode=${zipCode}`;

const isCached = (data: AvailabilityBigTicketStoreState['data'], objectKey: string): boolean => !!data[objectKey];

export default defineStore('availabilityBigTicketStore', {
  state: (): AvailabilityBigTicketStoreState => ({
    data: {},
    zipCode: '',
    zipcodeSlideoutShown: false,
    previouslyFocusedElement: null,
    activeSlideout: null,
  }),
  actions: {
    async fetchAvailability({ lookupIds, zipCode }: fetchParams) {
      if (!zipCode) {
        console.error('zipCode is required');
        return;
      }
      if (!lookupIds) {
        console.error('lookupIds is required');
        return;
      }

      const url = buildUrl(lookupIds, zipCode);
      const objectKey = `${zipCode}_${lookupIds}`;

      if (isCached(this.data, objectKey)) {
        return;
      }
      const result = await get(url);

      this.data[objectKey] = result;
    },
    // Actions below can be removed if we change the way how we use these within the component.
    setZip(zipCode: string) {
      this.zipCode = zipCode;
    },

    setZipCodeSlideoutShown(value: boolean) {
      this.zipcodeSlideoutShown = value;
    },

    setPreviouslyFocusedElement(value: AvailabilityBigTicketStoreState['previouslyFocusedElement']) {
      this.previouslyFocusedElement = value;
    },

    setActiveSlideout(slideoutId: number) {
      this.activeSlideout = slideoutId;
    },
  },
});
